const Backbone = require('backbone');
const dustjs = require('dustjs');
const BookAppointmentTemplate = require('app/templates/store/global/common/_book_appointment.dust');
const { ZipChangerView } = require('app/views/store/common/zip_changer');

const BookAppointmentView = Backbone.View.extend({
	events: {
		'click .js-change-showroom-zip': '_showChangeZipForm'
	},
	initialize() {
		this.container = this.$el.find('.js-book-appointment-container');
		this.initialPostalCode = this.container.data('postalCode') ? this.container.data('postalCode').toString() : '';
		this.zipChangerView = new ZipChangerView({
			zip: this.initialPostalCode
		});
		this.listenTo(Backbone, 'zipCode:changed', this._handleZipCodeChange.bind(this));
	},
	_showChangeZipForm() {
		if (this.zipChangerView) {
			this.zipChangerView.toggleForm();
		}
	},
	_handleZipCodeChange(postalCode) {
		if (postalCode && postalCode !== this.initialPostalCode) {
			this.initialPostalCode = postalCode;
			dustjs.render(
				BookAppointmentTemplate,
				{
					postalCode: this.initialPostalCode
				},
				this._handleRenderResponse.bind(this)
			);
		} else {
			this._showChangeZipForm();
		}
	},
	_handleRenderResponse(err, output) {
		if (err) {
			window.clientErrorHandler(err);
		}
		this.$el.html(output);

		this.zipChangerView = new ZipChangerView({
			zip: this.initialPostalCode
		});
	}
});

module.exports = BookAppointmentView;
